import moment from 'moment'

export const getHotelDisplayName = (hotelName, index, isDemoMode) => {
  if (isDemoMode) {
    return `Hotel ${index + 1}`
  }
  return hotelName
}

export const sortResults = (results, sortIndex, sortAscending) => {
  const sortedData = results.sort((a, b) => {
    switch (sortIndex) {
      case 0:
        if (a.fullName === b.fullName) return 0

        return a?.fullName?.toUpperCase() > b?.fullName?.toUpperCase() ? 1 : -1

      case 1:
        return new Date(a.otaBooking?.agencyName) - new Date(b.otaBooking?.agencyName)

      case 2:
        return new Date(a.otaBooking?.bookingDate) - new Date(b.otaBooking?.bookingDate)

      case 3:
        return new Date(a.otaBooking?.checkIn) - new Date(b.otaBooking?.checkIn)

      case 4:
        return new Date(a.directBooking?.textedOn) - new Date(b.directBooking?.textedOn)

      case 5:
        return (
          new Date(a.directBooking?.bookingDate) - new Date(b.directBooking?.bookingDate)
        )

      case 6:
        return new Date(a.directBooking?.checkIn) - new Date(b.directBooking?.checkIn)

      case 7:
        return Number(a.directBooking?.totalRate) - Number(b.directBooking?.totalRate)

      default:
        return 0
    }
  })

  return sortAscending ? sortedData : [...sortedData].reverse()
}

export const getDateRange = (date1, date2) => {
  if (moment(date1).format('MMM') === moment(date2).format('MMM')) {
    return `${moment(date1).format('MMM')} ${moment(date1).format('D')} - ${moment(
      date2
    ).format('D')}`
  } else {
    return `${moment(date1).format('MMM D')} - ${moment(date2).format('MMM D')}`
  }
}
